<template>
  <div>
    <div id="components-form-demo-advanced-search">
      <a-form class="ant-advanced-search-form" :form="form" @submit="handleSearch">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="发布状态">
              <a-select
                  style="width: 150px"
                  :allowClear="true"
                  v-decorator="['publishStatus']"
                  :options="statusList"
                  :disabled="false"
                  placeholder="全部状态"
              >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <a-form-item label="标题名称">
              <a-input
                  v-decorator="[`actTitle`]"
                  placeholder="请输入标题名称搜索"
              />
            </a-form-item>
          </a-col>

          <a-col :span="6" :style="{ textAlign: 'right',lineHeight:'42px' }">
            <a-button type="primary" html-type="submit">
              搜索
            </a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="handleReset">
              重置
            </a-button>
          </a-col>
        </a-row>

      </a-form>
    </div>
    <a-list
        :grid="{ gutter: 35, xs: 2, sm: 2, md: 4, lg: 4, xl: 6, xxl: 6 }"
        :data-source="marketListData"
        :pagination="pagination"
        style="width: 100%;"
    >
      <a-list-item slot="renderItem" slot-scope="item">

        <div class="item_box new pr" @click="createNew" v-if="item.isFirst">
          <p class="new_icon">
            <a-icon type="plus-circle" theme="filled"/>
          </p>
          <p class="new_tips tr">创建活动</p>
        </div>

        <div class="item_box pr" v-else>
          <div class="img_box pr" @click="showDetail(item.actId)"
               :style="{backgroundImage:'url(' + api.temp.FILE_PATH + item.backgroundImg + ')'}">
            <img v-if="item.frontImg" :src="api.temp.FILE_PATH + item.frontImg">
            <div class="pop_btns pa">
              <div class="top_btns">
                <span class="status" :class="item.publishStatus === 1?'active':''">{{ item.statusName }}</span>
                <p class="icons">
                  <span class="icon">
                    <a-icon type="edit" @click.stop="showDetail(item.actId)"/>
                  </span>
                  <a-popconfirm title="确定删除吗？" ok-text="确定" cancel-text="取消" @confirm="deleteItem(item.actId)">
                    <span class="icon" @click.stop="e => e.preventDefault()"><a-icon type="delete"/></span>
                  </a-popconfirm>
                  <a-dropdown>
                    <a class="ant-dropdown-link" @click.stop="e => e.preventDefault()">
                      <span class="icon"><a-icon type="ellipsis"/></span>
                    </a>
                    <a-menu slot="overlay" @click="onClick">
                      <a-menu-item v-if="item.publishStatus === 1" @click="handleChangeStatus(item.actId,0)">
                        取消发布
                      </a-menu-item>
                      <a-menu-item v-else @click="handleChangeStatus(item.actId,1)">
                        发布
                      </a-menu-item>
                      <a-menu-item key="2" @click="checkPrizeInfo(item.actId)">查看中奖记录</a-menu-item>

                      <!--                      <a-menu-item key="2">统计数据</a-menu-item>-->
                      <!--                      <a-menu-item key="3">下发分享任务</a-menu-item>-->
                      <!--                      <a-menu-item key="4">复制</a-menu-item>-->
                      <!--                      <a-menu-item key="5">预览</a-menu-item>-->
                    </a-menu>
                  </a-dropdown>
                </p>
              </div>
            </div>
          </div>
          <div class="title_box">
            <p class="title el2">{{ item.actTitle }}</p>
          </div>
        </div>

      </a-list-item>
    </a-list>

    <!-- 文章营销详情 -->
    <a-modal
        title="活动详情"
        centered
        :closable="true"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        wrapClassName="manage-detail"
        :width="1200"
        @cancel="closeEdit"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm
          :rowId="editRowId"
          v-if="editModalVisible"
          ref="form"
          @cancelled="closeEdit()"
          @saved="closeEdit(true)"
      >
      </detailForm>

    </a-modal>
    <a-modal
        title="中奖信息"
        centered
        :footer="null"
        :maskClosable="false"
        v-model="prizeModalVisible"
        :width="1200"
    >
      <prizeForm :actId="actId" v-if="prizeModalVisible" ref="prizeForm"></prizeForm>
    </a-modal>

  </div>
</template>
<script>
// 接口API
import {dataApi} from "@/services/market/active";
// 表单
import detailForm from "./detail";
import api from "@/services/api";
import prizeForm from "@/pages/web/market/activeManage/prizeInfo";

export default {
  data() {
    return {
      expand: false,
      form: this.$form.createForm(this, {name: 'advanced_search'}),
      statusList: [{
        title: '未发布',
        value: 0
      }, {
        title: '已发布',
        value: 1
      }, {
        title: '已下线',
        value: 2
      }],
      api,
      marketListData: [],
      editModalVisible: false,
      pagination: {
        onChange: (page) => {
          if (page > 2) {
            this.pagination.pageSize = 12;
          } else {
            this.pagination.pageSize = 11;
          }
        },
        pageSize: 11
      },
      editRowId: 0,
      prizeModalVisible: false,
      actId: 0
    };
  },
  components: {
    detailForm, prizeForm
  },
  mounted() {
    this.marketList();
  },
  methods: {
    createNew() {
      this.editRowId = 0;
      this.editModalVisible = true;
    },
    closeEdit() {
      this.editModalVisible = false;
      this.marketList();
    },
    showDetail(id) {
      this.editRowId = id;
      this.editModalVisible = true;
    },
    deleteItem(id) {
      let $_that = this;

      dataApi.deleteMarketItem(id).then(entity => {
        if (entity.code === 200) {
          $_that.marketList();
          this.reload();
          // window.location.reload();
        }
      });

      // this.$confirm({
      //   title: '确认删除？',
      //   async onOk() {
      //     let entity = await dataApi.deleteMarketItem(id);
      //     if (entity.code === 200) {
      //       $_that.marketList();
      //       window.location.reload();
      //     }
      //   }
      // })
    },
    async handleChangeStatus(actId, status) {
      var that = this;
      let result = {
        'actId': actId,
        'status': status,
      }
      let entity = await dataApi.changeStatus(result);
      if (entity.code === 200) {
        that.marketList();
        that.refresh();
      }
    },
    async marketList(result) {
      let entity = await dataApi.getMarketList(result, 10010);
      if (entity.code === 200) {
        entity.data.list.forEach(item => {
          item.tagNameList = item.tagNames ? item.tagNames.split(',') : [];
        })
        entity.data.list.unshift({
          isFirst: true
        })
        this.marketListData = entity.data.list;
        console.log('marketListData', this.marketListData)
      }
    },
    onClick({key}) {
      console.log(`Click on item ${key}`);
    },
    async handleSearch(e) {
      e.preventDefault();
      // let searchResult;
      this.form.validateFields((error, values) => {
        let searchResult = {
          'filter.inNumbers.publishStatus': values.publishStatus,
          'filter.like.actTitle': values.actTitle,
        }
        this.marketList(searchResult)
        this.refresh();
      });
    },

    handleReset() {
      this.form.resetFields();
      this.marketList();
    },
    checkPrizeInfo(actId) {
      this.actId = actId;
      this.prizeModalVisible = true;
    }


    // toggle() {
    //   this.expand = !this.expand;
    // },
  }
};
</script>
<style scoped lang="less">

@import "../../../../assets/css/marketList.less";

.ant-advanced-search-form {
  padding: 24px 24px 12px;
  background: #fbfbfb;
  border: 1px solid #e1e1e1;
  border-radius: 6px;
  margin-bottom: 12px;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}


</style>